import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';

export default function BankManualUploadErrorAlert({ manualUploadData }) {
  if (!manualUploadData) return null;

  const isPanMismatch = Boolean(manualUploadData.isPanNameMismatch);
  const showPanGrid = isPanMismatch
    && (manualUploadData.pan_name
      || manualUploadData.bank_name
      || manualUploadData.mismatch_bank?.beneficiary_name);

  return (
    <div className="flex flex-col gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4">
      <div className="flex items-start gap-2">
        <FiAlertCircle size={18} className="mt-0.5 shrink-0 text-amber-600" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-amber-900">
            {isPanMismatch ? 'Bank name does not match PAN' : 'Bank verification failed'}
          </p>
          <p className="mt-1 wrap-break-word text-sm text-amber-800 whitespace-pre-wrap">
            {manualUploadData.serverMessage}
          </p>
          <p className="mt-1 text-sm text-amber-800">
            Please confirm the account details and upload a cancelled cheque for manual review.
          </p>
        </div>
      </div>

      {showPanGrid ? (
        <div className="grid grid-cols-1 gap-2 text-sm sm:grid-cols-2">
          <div className="rounded-lg border border-amber-100 bg-white/80 px-3 py-2">
            <span className="text-xs font-medium uppercase tracking-wide text-amber-700">PAN name</span>
            <p className="mt-0.5 font-semibold text-gray-900">{manualUploadData.pan_name || '—'}</p>
          </div>
          <div className="rounded-lg border border-amber-100 bg-white/80 px-3 py-2">
            <span className="text-xs font-medium uppercase tracking-wide text-amber-700">Bank name</span>
            <p className="mt-0.5 font-semibold text-gray-900">
              {manualUploadData.bank_name || manualUploadData.mismatch_bank?.beneficiary_name || '—'}
            </p>
          </div>
        </div>
      ) : null}

      {manualUploadData.match_score != null ? (
        <p className="text-xs text-amber-700">
          Name match score:{' '}
          <span className="font-semibold">{Math.round(Number(manualUploadData.match_score))}</span>
          {manualUploadData.required_threshold != null ? (
            <> / {manualUploadData.required_threshold} required</>
          ) : null}
        </p>
      ) : null}
    </div>
  );
}
